import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourceLineageCountsFragmentGql } from './DatasourceLineageCountsFragmentGql';

export const DatasourceLineageCountsQueryGql: DocumentNode = gql`
query DatasourceLineageCountsQuery($vizportalUrlId: String!, $publishedConnectionsLineageEnabled: Boolean!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...DatasourceLineageCountsFragment
  }
}
${DatasourceLineageCountsFragmentGql}
`;
